import React, { useState } from 'react';
import { styles } from './CouponModal.css';
import { LoadingSkeleton } from '../LoadingSkeleton/LoadingSkeleton';
import { Barcode } from '../Barcode';
import Alert from '@jbhi-fi/lanyard-ui/components/Alert';
import { WalletButton } from '../Account/JBWallet/WalletButton';
import { getErrorMessage } from './utils';
import { CouponWalletContent } from './constants';

type BarcodeContainerProps = {
  couponCode: string;
  barcode?: string;
  barcodeLabel?: string;
  additonalInstructions?: JSX.Element;
  setQrModalContent: ({ qrCode, isOpen }: { qrCode?: string; isOpen: boolean }) => void;
  getCouponWalletContent: ({
    couponCode,
    shouldGenerateQrCode,
    platform,
  }: {
    couponCode?: string;
    shouldGenerateQrCode?: boolean;
    platform?: 'ios' | 'android';
  }) => Promise<CouponWalletContent>;
  shouldShowAddToWalletButtons?: boolean;
};

export const BarcodeContainer = ({
  couponCode,
  barcode,
  barcodeLabel,
  additonalInstructions,
  setQrModalContent,
  getCouponWalletContent,
  shouldShowAddToWalletButtons,
}: BarcodeContainerProps) => {
  const [walletErrorCode, setWalletErrorCode] = useState<number | null>(null);
  return barcode ? (
    <div className={styles.barcodeContainer}>
      <h5 className={styles.barcodeLabel}>{barcodeLabel || 'Redeem in-store'}</h5>
      {shouldShowAddToWalletButtons ? (
        <>
          {walletErrorCode ? (
            <div className={styles.alertContainer}>
              <Alert type="error" heading={getErrorMessage(walletErrorCode)} noMargin />
            </div>
          ) : (
            <div className={styles.addToWalletContainer}>
              <WalletButton
                cardType="coupon"
                location="modal"
                couponCode={couponCode}
                setQrModalContent={setQrModalContent}
                getCouponWalletContent={getCouponWalletContent}
                setWalletErrorCode={setWalletErrorCode}
              />
            </div>
          )}
        </>
      ) : null}
      <div className={styles.barcodeInstructions}>
        {additonalInstructions || 'Show the barcode to our staff at the counter.'}
      </div>
      <div className={styles.barcodeImageContainer}>
        <Barcode barcodeBase64={barcode} />
        <h4 className={styles.barcodeText}>{couponCode}</h4>
      </div>
    </div>
  ) : (
    <LoadingSkeleton.Image
      className={styles.loadingSkeleton}
      border="none"
      aspectRatio={2}
      shouldShimmer={true}
      width="50%"
    />
  );
};
